import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { SchoolYearFormatPipe } from '../../../shared/pipe/school-year-format.pipe';
import { MatMenuModule } from '@angular/material/menu';

const MATERIALS = [
  MatButtonModule, MatIconModule, MatSelectModule, 
  MatMenuModule
];

@Component({
  selector: 'app-header',
  imports: [...MATERIALS, CommonModule, MatButtonModule, MatIconModule, MatSelectModule, SchoolYearFormatPipe],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  @Input() establishments: any[] | null = [];
  @Input() selectedEstablishmentId: string | number | undefined | null;
  @Input() currentSchoolYear: any | null;
  @Input() userName: string | null = null;

  get selectedEstablishment(): any {
    return this.establishments?.find(e => e.id === this.selectedEstablishmentId);
  }

  @Output() schoolChanged = new EventEmitter<string>();
  @Output() schoolYearChanged = new EventEmitter<number>();
  @Output() logoutClicked = new EventEmitter<void>();

  onSchoolChange(event: MatSelectChange) {
    this.schoolChanged.emit(event.value);
  } 
  
  onSchoolYearChange(event: MatSelectChange) {
    this.schoolYearChanged.emit(event.value);
  }

  onLogout() {
    this.logoutClicked.emit();
  }
}
